import { mapSelbstbeteiligungProzent } from '@ps20-frontend/migrations';
import { Vertragsoptionen } from '@ps20-frontend/frontend-models';
import { StatePreV3, StateV3 } from './3_migrate_selbstbeteiligung.interface';

export const migrateSelbstbeteiligung = (
  previousState: StatePreV3,
  newVersion: number,
): StateV3 => {
  return {
    ...previousState,
    version: newVersion,
    vertragsoptionen: {
      ...previousState.vertragsoptionen,
      selbstbeteiligung: mapSelbstbeteiligungProzent(
        previousState.vertragsoptionen.selbstbeteiligung,
      ),
    } as Vertragsoptionen,
  };
};
